import gifIcon from './gif-icon-512.png';
import videoIcon from './video-icon-512.png';
import webpIcon from './webp-icon.svg';

const baseInfo = {
    // width: 49 * 2,
    // height: 46 * 2,
    // width: 145,
    // height: 138,
    sizeRatio: 36 / 176,
    paddingRatio: 6 / 176,
};

export const VIDEO_IDENTIFIER_ICON = {
    width: 512,
    height: 485,
    ...baseInfo,
    sizeRatio: (81 * 3) / (176 * 4),
    src: videoIcon,
};

export const GIF_IDENTIFIER_ICON = {
    width: 512,
    height: 489,
    ...baseInfo,
    src: gifIcon,
};

/** WebP 动态图片角标，沿用 GIF 角标的缩放及留白比例 */
export const WEBP_IDENTIFIER_ICON = {
    ...GIF_IDENTIFIER_ICON,
    src: webpIcon,
};
